import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

//"start": "node --max_old_space_size=6144 node_modules/.bin/react-scripts start",
// "build": "node --max_old_space_size=6144 node_modules/.bin/react-scripts build",
